import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '@marvelapp/ballpark-components';
import ErrorBox from './ErrorBox';
// eslint-disable-next-line mobx/missing-observer
export default function EntireScreenShareError() {
    return (_jsxs(ErrorBox, { children: [_jsx(Text, { fontSize: "s", display: "block", children: _jsx(FormattedMessage, { id: 'ufmbyh', defaultMessage: 'We couldn\'t set up your screen sharing.' }) }), _jsx(Text, { fontSize: "s", display: "block", mt: "xs", children: _jsx(FormattedMessage, { id: 'V03+0c', defaultMessage: 'Please select \u2018Entire screen\u2019 when sharing the contents of your screen' }) })] }));
}
